export default "__VITE_ASSET__DUq6uJ_6__"